/**
 * AlmadarPostWhatIfSoftwareCouldBuildItselfSLAlmadarPostWhatIfSoftwareCouldBuildItselfSLPage
 *
 * Page component for AlmadarPostWhatIfSoftwareCouldBuildItselfSLAlmadarPostWhatIfSoftwareCouldBuildItselfSLPage
 * Path: /sl/blog/what-if-software-could-build-itself
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageView as __AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageView';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostAnalyticsView as __AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostAnalyticsView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWhatIfSoftwareCouldBuildItselfSLAlmadarPostWhatIfSoftwareCouldBuildItselfSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostWhatIfSoftwareCouldBuildItselfSLAlmadarPostWhatIfSoftwareCouldBuildItselfSLPage(_props: AlmadarPostWhatIfSoftwareCouldBuildItselfSLAlmadarPostWhatIfSoftwareCouldBuildItselfSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWhatIfSoftwareCouldBuildItselfSLAlmadarPostWhatIfSoftwareCouldBuildItselfSLPage;
